/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S3_Li1Inputs */

const tr_onbilgi_s3_li1 = /** @type {(inputs: Onbilgi_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik aylık veya yıllık olarak seçilir; yıllık tercihte indirim uygulanır.`)
};

const en_onbilgi_s3_li1 = /** @type {(inputs: Onbilgi_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The subscription is selected on a monthly or annual basis; a discount applies to the annual option.`)
};

const de_onbilgi_s3_li1 = /** @type {(inputs: Onbilgi_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Abonnement wird monatlich oder jährlich gewählt; bei der jährlichen Wahl wird ein Rabatt gewährt.`)
};

const ru_onbilgi_s3_li1 = /** @type {(inputs: Onbilgi_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписка оформляется на месяц или на год; при выборе годовой подписки предоставляется скидка.`)
};

/**
* | output |
* | --- |
* | "The subscription is selected on a monthly or annual basis; a discount applies to the annual option." |
*
* @param {Onbilgi_S3_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s3_li1 = /** @type {((inputs?: Onbilgi_S3_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S3_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s3_li1(inputs)
	if (locale === "de") return de_onbilgi_s3_li1(inputs)
	if (locale === "ru") return ru_onbilgi_s3_li1(inputs)
	return tr_onbilgi_s3_li1(inputs)
});